<template>
  <v-container fluid>
    <v-row align="center" justify="center" class="mb-5 mt-3">
      <h1>
        <span class="orange--text text--darken-1 font-weight-medium">Choose </span>
        <span class="blue--text text--lighten-1 font-weight-medium">Your </span>
        <span class="light-green--text text--lighten-1 font-weight-medium">Website</span>
      </h1>
    </v-row>
    <v-row align="center" justify="center" class="my-5">
      <p class="white--text text-title text-md-h6">
        <span class="orange--text text--darken-1">See</span> the website template,
        <span class="blue--text text--lighten-1">Choose</span> a website template,
        <span class="light-green--text text--lighten-1">I</span> will turn it into your
        website.
      </p>
    </v-row>

    <v-row>
      <v-tabs v-model="web" background-color="var(--var1)" dark>
        <v-tab v-for="website in websites" :key="website.web">
          <v-badge color="red" :content="website.content.length">
            {{ website.web }}</v-badge>
        </v-tab>
      </v-tabs>
    </v-row>

    <v-card tile elevation="10">
      <v-tabs-items v-model="web" style="background-color: var(--var4)" class="mt-10">
        <v-tab-item v-for="website in websites" :key="website.web">
          <v-card v-for="(content, index) in website.content" :key="index" class="mb-16">
            <a :href="content.to">
              <v-app-bar dark shrink :src="content.background">
                <v-row style="align-items: center">
                  <v-col cols="6">
                    <v-btn color="red" cols="3"> {{ content.name }} </v-btn>
                  </v-col>
                  <v-col cols="6" class="text-right">
                    <v-btn icon>
                      <v-icon color="green accent-3">mdi-web</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-app-bar>
            </a>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <!-- <v-row class="mb-5 mx-10 mt-16">
      <v-btn>
        <v-badge color="green" :content="TemplateCount">Template Total</v-badge>
      </v-btn>
      <v-btn @click="filterWebsites('all')">All</v-btn>
      <v-btn @click="filterWebsites('website')">Website</v-btn>
      <v-btn @click="filterWebsites('blog')">Blog</v-btn>
      <v-btn @click="filterWebsites('portfolio')">Portfolio</v-btn>
      <v-btn @click="filterWebsites('admin')">Admin</v-btn>
    </v-row> -->
    <!-- <v-card v-for="(website, index) in filteredWebsites" :key="index" class="mb-16">
      <router-link :to="website.to">
        <v-app-bar color="#fcb69f" dark shrink :src="website.background">
          <v-row style="align-items: center">
            <v-col cols="6">
              <v-btn color="red" cols="3"> {{ website.name }} </v-btn>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn icon>
                <v-icon color="green accent-3">mdi-web</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-app-bar>
      </router-link>
    </v-card> -->
    <v-scale-transition>
      <v-btn fab v-show="fab" v-scroll="onScroll" dark fixed bottom right color="#7F5AF0" @click="toTop"
        title="back to top">
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-scale-transition>
  </v-container>
</template>

<style>
.v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)>.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none !important;
}
</style>

<script>
export default {
  metaInfo() {
    return {
      title: this.$route.meta.title,
    };
  },
  mounted() {
    document.title = this.$route.meta.title;
    window.scrollTo(0, 0);
  },
  watch: {
    fab(value) {
      if (value) {
        this.color = "#121F3E";
        this.flat = false;
      } else {
        this.color = "#0E172C";
        this.flat = true;
      }
    },

    dialog(value) {
      if (!value) {
        this.pause();
      }
    },
  },
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
  data() {
    return {
      web: null,
      fab: null,
      websites: [
        {
          web: "Website",
          content: [
            {
              to: "Alstar-pro",
              background: require("@/assets/img_project/Alstar-pro.png"),
              name: "Alstar-Pro Template",
              category: "website",
            },
            {
              to: "Amoeba-pro",
              background: require("@/assets/img_project/Amoeba-pro.png"),
              name: "Amoeba-Pro Template",
              category: "website",
            },
            {
              to: "Anyar-pro",
              background: require("@/assets/img_project/Anyar-pro.png"),
              name: "Anyar-Pro Template",
              category: "website",
            },
            {
              to: "Appland-pro",
              background: require("@/assets/img_project/Appland-pro.png"),
              name: "Appland-Pro Template",
              category: "website",
            },
            {
              to: "Arsha-pro",
              background: require("@/assets/img_project/Arsha-pro.png"),
              name: "Arsha-Pro Template",
              category: "website",
            },
            {
              to: "Avilon-pro",
              background: require("@/assets/img_project/Avilon-pro.png"),
              name: "Avilon-Pro Template",
              category: "website",
            },
            {
              to: "Baker-pro",
              background: require("@/assets/img_project/Baker-pro.png"),
              name: "Baker-Pro Template",
              category: "website",
            },
            {
              to: "Bell-pro",
              background: require("@/assets/img_project/Bell-pro.png"),
              name: "Bell-Pro Template",
              category: "website",
            },
            {
              to: "Bethany-pro",
              background: require("@/assets/img_project/Bethany-pro.png"),
              name: "Bethany-Pro Template",
              category: "website",
            },
            {
              to: "Bikin-pro",
              background: require("@/assets/img_project/Bikin-pro.png"),
              name: "Bikin-Pro Template",
              category: "website",
            },
            {
              to: "BizLand-pro",
              background: require("@/assets/img_project/Bizland-pro.png"),
              name: "Bizland-Pro Template",
              category: "website",
            },
            {
              to: "BizPage-pro",
              background: require("@/assets/img_project/Bizpage-pro.png"),
              name: "Bizpage-Pro Template",
              category: "website",
            },
            {
              to: "Bocor-pro",
              background: require("@/assets/img_project/Bocor-pro.png"),
              name: "Bocor-Pro Template",
              category: "website",
            },
            {
              to: "Bootslander-pro",
              background: require("@/assets/img_project/Bootslander-pro.png"),
              name: "Bootslander-Pro Template",
              category: "website",
            },
            {
              to: "Butterfly-pro",
              background: require("@/assets/img_project/Butterfly-pro.png"),
              name: "Butterfly-Pro Template",
              category: "website",
            },
            {
              to: "ComingSoon-pro",
              background: require("@/assets/img_project/ComingSoon-pro.png"),
              name: "ComingSoon-Pro Template",
              category: "website",
            },
            {
              to: "Company-pro",
              background: require("@/assets/img_project/Company-pro.png"),
              name: "Company-Pro Template",
              category: "website",
            },
            {
              to: "Day-pro",
              background: require("@/assets/img_project/Day-pro.png"),
              name: "Day-Pro Template",
              category: "website",
            },
            {
              to: "Delicious-pro",
              background: require("@/assets/img_project/Delicious-pro.png"),
              name: "Delicious-Pro Template",
              category: "website",
            },
            {
              to: "Dewi-pro",
              background: require("@/assets/img_project/Dewi-pro.png"),
              name: "Dewi-Pro Template",
              category: "website",
            },
            {
              to: "EstateAgency-pro",
              background: require("@/assets/img_project/EstateAgency-pro.png"),
              name: "EstateAgency-Pro Template",
              category: "website",
            },
            {
              to: "Eterna-pro",
              background: require("@/assets/img_project/Eterna-pro.png"),
              name: "Eterna-Pro Template",
              category: "website",
            },
            {
              to: "Flattern-pro",
              background: require("@/assets/img_project/Flattern-pro.png"),
              name: "Flattern-Pro Template",
              category: "website",
            },
            {
              to: "FlexStart-pro",
              background: require("@/assets/img_project/FlexStart-pro.png"),
              name: "FlexStart-Pro Template",
              category: "website",
            },
            {
              to: "Flexor-pro",
              background: require("@/assets/img_project/Flexor-pro.png"),
              name: "Flexor-Pro Template",
              category: "website",
            },
            {
              to: "Gp-pro",
              background: require("@/assets/img_project/Gp-pro.png"),
              name: "Gp-Pro Template",
              category: "website",
            },
            {
              to: "Green-pro",
              background: require("@/assets/img_project/Green-pro.png"),
              name: "Green-Pro Template",
              category: "website",
            },
            {
              to: "Groovin-pro",
              background: require("@/assets/img_project/Groovin-pro.png"),
              name: "Groovin-Pro Template",
              category: "website",
            },
            {
              to: "HeroBiz-pro",
              background: require("@/assets/img_project/HeroBiz-pro.png"),
              name: "HeroBiz-Pro Template",
              category: "website",
            },
            {
              to: "Hidayah-pro",
              background: require("@/assets/img_project/Hidayah-pro.png"),
              name: "Hidayah-Pro Template",
              category: "website",
            },
            {
              to: "Impact-pro",
              background: require("@/assets/img_project/Impact-pro.png"),
              name: "Impact-Pro Template",
              category: "website",
            },
            {
              to: "Imperial-pro",
              background: require("@/assets/img_project/Imperial-pro.png"),
              name: "Imperial-Pro Template",
              category: "website",
            },
            {
              to: "Kelly-pro",
              background: require("@/assets/img_project/Kelly-pro.png"),
              name: "Kelly-Pro Template",
              category: "website",
            },
            {
              to: "Knight-pro",
              background: require("@/assets/img_project/Knight-pro.png"),
              name: "Knight-Pro Template",
              category: "website",
            },
            {
              to: "KnightOne-pro",
              background: require("@/assets/img_project/KnightOne-pro.png"),
              name: "KnightOne-Pro Template",
              category: "website",
            },
            {
              to: "Laura-pro",
              background: require("@/assets/img_project/Laura-pro.png"),
              name: "Laura-Pro Template",
              category: "website",
            },
            {
              to: "Logis-pro",
              background: require("@/assets/img_project/Logis-pro.png"),
              name: "Logis-Pro Template",
              category: "website",
            },
            {
              to: "Lonely-pro",
              background: require("@/assets/img_project/Lonely-pro.png"),
              name: "Lonely-Pro Template",
              category: "website",
            },
            {
              to: "Lumia-pro",
              background: require("@/assets/img_project/Lumia-pro.png"),
              name: "Lumia-Pro Template",
              category: "website",
            },
            {
              to: "Mamba-pro",
              background: require("@/assets/img_project/Mamba-pro.png"),
              name: "Mamba-Pro Template",
              category: "website",
            },
            {
              to: "Maundy-pro",
              background: require("@/assets/img_project/Maundy-pro.png"),
              name: "Maundy-Pro Template",
              category: "website",
            },
            {
              to: "Maxim-pro",
              background: require("@/assets/img_project/Maxim-pro.png"),
              name: "Maxim-Pro Template",
              category: "website",
            },
            {
              to: "MeFamily-pro",
              background: require("@/assets/img_project/MeFamily-pro.png"),
              name: "MeFamily-Pro Template",
              category: "website",
            },
            {
              to: "Medicio-pro",
              background: require("@/assets/img_project/Medicio-pro.png"),
              name: "Medicio-Pro Template",
              category: "website",
            },
            {
              to: "Medilab-pro",
              background: require("@/assets/img_project/Medilab-pro.png"),
              name: "Medilab-Pro Template",
              category: "website",
            },
            {
              to: "Mentor-pro",
              background: require("@/assets/img_project/Mentor-pro.png"),
              name: "Mentor-Pro Template",
              category: "website",
            },
            {
              to: "Moderna-pro",
              background: require("@/assets/img_project/Moderna-pro.png"),
              name: "Moderna-Pro Template",
              category: "website",
            },
            {
              to: "Multi-pro",
              background: require("@/assets/img_project/Multi-pro.png"),
              name: "Multi-Pro Template",
              category: "website",
            },
            {
              to: "MyBiz-pro",
              background: require("@/assets/img_project/MyBiz-pro.png"),
              name: "MyBiz-Pro Template",
              category: "website",
            },
            {
              to: "NewBiz-pro",
              background: require("@/assets/img_project/NewBiz-pro.png"),
              name: "NewBiz-Pro Template",
              category: "website",
            },
            {
              to: "Ninestars-pro",
              background: require("@/assets/img_project/Ninestars-pro.png"),
              name: "Ninestars-Pro Template",
              category: "website",
            },
            {
              to: "Nova-pro",
              background: require("@/assets/img_project/Nova-pro.png"),
              name: "Nova-Pro Template",
              category: "website",
            },
            {
              to: "OnePage-pro",
              background: require("@/assets/img_project/OnePage-pro.png"),
              name: "OnePage-Pro Template",
              category: "website",
            },
            {
              to: "Personal-pro",
              background: require("@/assets/img_project/Personal-pro.png"),
              name: "Personal-Pro Template",
              category: "website",
            },
            {
              to: "Plato-pro",
              background: require("@/assets/img_project/Plato-pro.png"),
              name: "Plato-Pro Template",
              category: "website",
            },
            {
              to: "Presento-pro",
              background: require("@/assets/img_project/Presento-pro.png"),
              name: "Presento-Pro Template",
              category: "website",
            },
            {
              to: "Rapid-pro",
              background: require("@/assets/img_project/Rapid-pro.png"),
              name: "Rapid-Pro Template",
              category: "website",
            },
            {
              to: "Regna-pro",
              background: require("@/assets/img_project/Regna-pro.png"),
              name: "Regna-Pro Template",
              category: "website",
            },
            {
              to: "Remember-pro",
              background: require("@/assets/img_project/Remember-pro.png"),
              name: "Remember-Pro Template",
              category: "website",
            },
            {
              to: "Resi-pro",
              background: require("@/assets/img_project/Resi-pro.png"),
              name: "Resi-Pro Template",
              category: "website",
            },
            {
              to: "Restaurantly-pro",
              background: require("@/assets/img_project/Restaurantly-pro.png"),
              name: "Restaurantly-Pro Template",
              category: "website",
            },
            {
              to: "Reveal-pro",
              background: require("@/assets/img_project/Reveal-pro.png"),
              name: "Reveal-Pro Template",
              category: "website",
            },
            {
              to: "Sailor-pro",
              background: require("@/assets/img_project/Sailor-pro.png"),
              name: "Sailor-Pro Template",
              category: "website",
            },
            {
              to: "Scaffold-pro",
              background: require("@/assets/img_project/Scaffold-pro.png"),
              name: "Scaffold-Pro Template",
              category: "website",
            },
            {
              to: "Selecao-pro",
              background: require("@/assets/img_project/Selecao-pro.png"),
              name: "Selecao-Pro Template",
              category: "website",
            },
            {
              to: "Serenity-pro",
              background: require("@/assets/img_project/Serenity-pro.png"),
              name: "Serenity-Pro Template",
              category: "website",
            },
            {
              to: "Shuffle-pro",
              background: require("@/assets/img_project/Shuffle-pro.png"),
              name: "Shuffle-Pro Template",
              category: "website",
            },
            {
              to: "Siimple-pro",
              background: require("@/assets/img_project/Siimple-pro.png"),
              name: "Siimple-Pro Template",
              category: "website",
            },
            {
              to: "SoftLand-pro",
              background: require("@/assets/img_project/SoftLand-pro.png"),
              name: "SoftLand-Pro Template",
              category: "website",
            },
            {
              to: "Squadfree-pro",
              background: require("@/assets/img_project/SquadFree-pro.png"),
              name: "SquadFree-Pro Template",
              category: "website",
            },
            {
              to: "Techie-pro",
              background: require("@/assets/img_project/Techie-pro.png"),
              name: "Techie-Pro Template",
              category: "website",
            },
            {
              to: "Tempo-pro",
              background: require("@/assets/img_project/Tempo-pro.png"),
              name: "Tempo-Pro Template",
              category: "website",
            },
            {
              to: "TheEvent-pro",
              background: require("@/assets/img_project/TheEvent-pro.png"),
              name: "TheEvent-Pro Template",
              category: "website",
            },
            {
              to: "UpConstruction-pro",
              background: require("@/assets/img_project/UpConstruction-pro.png"),
              name: "UpConstruction-Pro Template",
              category: "website",
            },
            {
              to: "Valera-pro",
              background: require("@/assets/img_project/Valera-pro.png"),
              name: "Valera-Pro Template",
              category: "website",
            },
            {
              to: "Vesperr-pro",
              background: require("@/assets/img_project/Vesperr-pro.png"),
              name: "Vesperr-Pro Template",
              category: "website",
            },
            {
              to: "Vlava-pro",
              background: require("@/assets/img_project/Vlava-pro.png"),
              name: "Vlava-Pro Template",
              category: "website",
            },
            {
              to: "WeBuild-pro",
              background: require("@/assets/img_project/WeBuild-pro.png"),
              name: "WeBuild-Pro Template",
              category: "website",
            },
            {
              to: "Yummy-pro",
              background: require("@/assets/img_project/Yummy-pro.png"),
              name: "Yummy-Pro Template",
              category: "website",
            },
            {
              to: "eBusiness-pro",
              background: require("@/assets/img_project/eBusiness-pro.png"),
              name: "eBusiness-Pro Template",
              category: "website",
            },
            {
              to: "eNno-pro",
              background: require("@/assets/img_project/eNno-pro.png"),
              name: "eNno-Pro Template",
              category: "website",
            },
            {
              to: "eStartup-pro",
              background: require("@/assets/img_project/eStartup-pro.png"),
              name: "eStartup-Pro Template",
              category: "website",
            },
          ],
        },
        {
          web: "portfolio",
          content: [
            {
              to: "DevFolio-pro",
              background: require("@/assets/img_project/DevFolio-pro.png"),
              name: "DevFolio-Pro Template",
              category: "portfolio",
            },
            {
              to: "Folio-pro",
              background: require("@/assets/img_project/Folio-pro.png"),
              name: "Folio-Pro Template",
              category: "portfolio",
            },
            {
              to: "MyPortfolio-pro",
              background: require("@/assets/img_project/MyPortfolio-pro.png"),
              name: "MyPortfolio-Pro Template",
              category: "portfolio",
            },
            {
              to: "MyResume-pro",
              background: require("@/assets/img_project/MyResume-pro.png"),
              name: "MyResume-Pro Template",
              category: "portfolio",
            },
            {
              to: "PhotoFolio-pro",
              background: require("@/assets/img_project/PhotoFolio-pro.png"),
              name: "PhotoFolio-Pro Template",
              category: "portfolio",
            },
            {
              to: "iPortfolio-pro",
              background: require("@/assets/img_project/iPortfolio-pro.png"),
              name: "iPortfolio-Pro Template",
              category: "portfolio",
            },
          ],
        },
        {
          web: "Admin",
          content: [
            {
              to: "NiceAdmin-pro",
              background: require("@/assets/img_project/NiceAdmin-pro.png"),
              name: "NiceAdmin-Pro Template",
              category: "admin",
            },
          ],
        },
        {
          web: "Blog",
          content: [
            {
              to: "ZenBlog-pro",
              background: require("@/assets/img_project/ZenBlog-pro.png"),
              name: "ZenBlog-Pro Template",
              category: "blog",
            },
          ],
        },
      ],
      selectedCategory: "all",
    };
  },
};
</script>
